export enum ChessColor {
    black,
    white,
}
